import { useEffect, useState } from 'react';
import {
  Paper, Typography, Grid, Chip, Table, TableHead, TableRow, TableCell, TableBody, Stack, Box,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DescriptionIcon from '@mui/icons-material/Description';
import InventoryIcon from '@mui/icons-material/Inventory';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import FolderIcon from '@mui/icons-material/Folder';
import DashboardLayout from '../components/DashboardLayout';
import api from '../services/api';

const STATUS_COLOR = { PENDING_REVIEW: 'warning', APPROVED: 'success', SUSPENDED: 'error', BLACKLISTED: 'error' };
const DOC_LABELS = {
  CAC_CERTIFICATE: 'CAC Certificate', TAX_CLEARANCE: 'Tax Clearance',
  PENCOM_CERTIFICATE: 'PENCOM Certificate', NSITF_CERTIFICATE: 'NSITF Certificate', ITF_CERTIFICATE: 'ITF Certificate',
};

function Field({ label, value }) {
  return (
    <Grid item xs={12} sm={6}>
      <Typography variant="caption" color="text.secondary">{label}</Typography>
      <Typography variant="body1">{value || '—'}</Typography>
    </Grid>
  );
}

export default function VendorProfile() {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get('/vendors/me/profile');
      setProfile(data.data);
    })();
  }, []);

  const nav = [
    { label: 'Dashboard', path: '/vendor', icon: <DashboardIcon /> },
    { label: 'Open Tenders', path: '/vendor/tenders', icon: <DescriptionIcon /> },
    { label: 'My Bids', path: '/vendor/bids', icon: <InventoryIcon /> },
    { label: 'Clarifications', icon: <QuestionAnswerIcon />, disabled: true },
    { label: 'Award Results', icon: <EmojiEventsIcon />, disabled: true },
    { label: 'Profile & Documents', path: '/vendor/profile', icon: <FolderIcon /> },
  ];

  return (
    <DashboardLayout nav={nav} title="Profile & Documents">
      {profile && (
        <>
          <Paper sx={{ p: 3, mb: 3 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
              <Typography variant="h6">Company information</Typography>
              <Chip label={profile.status.replace('_', ' ')} color={STATUS_COLOR[profile.status]} />
            </Stack>
            <Grid container spacing={2}>
              <Field label="Company Name" value={profile.companyName} />
              <Field label="CAC Registration Number" value={profile.cacNumber} />
              <Field label="TIN" value={profile.tin} />
              <Field label="Contact Person" value={profile.contactPerson} />
              <Field label="Email" value={profile.user?.email} />
              <Field label="Phone Number" value={profile.contactPhone} />
            </Grid>
            {profile.statusReason && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="caption" color="text.secondary">Review note</Typography>
                <Typography variant="body2">{profile.statusReason}</Typography>
              </Box>
            )}
          </Paper>

          <Typography variant="h6" sx={{ mb: 2 }}>Compliance documents</Typography>
          <Paper>
            <Table>
              <TableHead><TableRow><TableCell>Document</TableCell><TableCell>File</TableCell><TableCell>Uploaded</TableCell></TableRow></TableHead>
              <TableBody>
                {profile.complianceDocs?.map((d) => (
                  <TableRow key={d.id}>
                    <TableCell>{DOC_LABELS[d.docType] || d.docType}</TableCell>
                    <TableCell>{d.fileName}</TableCell>
                    <TableCell>{new Date(d.uploadedAt).toLocaleDateString('en-GB')}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </>
      )}
    </DashboardLayout>
  );
}
